<template>
  <div class="">
    <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
      <use :xlink:href="iconName"></use>
    </svg>
  </div>
</template>

<script>
// import { Component, Vue, Prop } from "vue-property-decorator";
export default {

  props: {
    iconClass: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconName() {
      console.log('🚀 ~ file: svg.vue ~ line 14 ~ iconName ~ this.iconClass', this.iconClass)
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
  },
}
</script>
<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  font-size: 18px;
}
</style>
